export default __webpack_public_path__ + "static/media/t3logo.25782220.png";